import { useTranslation } from "react-i18next";
import { FeedBotLogo } from "../brand/FeedBotLogo.js";
import { FeedBotMark } from "../brand/FeedBotMark.js";

/**
 * Product identity in the rail header: animated wordmark when expanded,
 * the FB-in-bubble mark when collapsed. Organization identity is a separate control.
 */
export function AppBrandMark({
  compact = false,
}: {
  compact?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();

  if (compact) {
    return <FeedBotMark className="size-7 shrink-0" label={t("app.name")} />;
  }

  return (
    <div className="flex min-w-0 flex-1 items-center justify-center">
      <FeedBotLogo
        tone="onDark"
        animated
        label={t("app.name")}
        className="h-12 w-[185px] max-w-full"
      />
    </div>
  );
}
